import BaseDecorator from "./BaseDecorator";
import ProductVariantDecorator from "./ProductVariantDecorator";
import ProductPricelistItemDecorator from "./ProductPricelistItemDecorator";
import PaymentProfileProductAttachmentDecorator from "./PaymentProfileProductAttachmentDecorator";
import ProductPickupPointDecorator from "./ProductPickupPointDecorator";

@BaseDecorator.translates(["additional_pickup_instructions"])
export default class ProductVariantFullDecorator extends ProductVariantDecorator {
  constructor({ name, ...data }) {
    super({
      ...data,
      coupon_discount_amount: data.coupon_discount_amount || null,
      coupon_discount_percentage: data.coupon_discount_percentage || null,
      coupon_offer_price_before_discount: data.coupon_offer_price_before_discount || null,

      translations: data.translations.map(
        (t) =>
          new BaseDecorator({
            ...t,
            name: t.name || null,
            short_description: t.short_description || null,
            // NOTE react-qull raises an error when its suddenly dismounted while being edited, so lets not nullify those values for now
            // deprecated_v1_includes_content: t.deprecated_v1_includes_content || null,
            // deprecated_v1_excludes_content: t.deprecated_v1_excludes_content || null,
            // deprecated_v1_requirements_content: t.deprecated_v1_requirements_content || null,
            included_items: t.included_items && t.included_items.length ? t.included_items : [],
            excluded_items: t.excluded_items && t.excluded_items.length ? t.excluded_items : [],
            customer_requirements:
              t.customer_requirements && t.customer_requirements.length ? t.customer_requirements : [],
            additional_pickup_instructions: t.additional_pickup_instructions || null,
          })
      ),

      product_pricelist_items: data.product_pricelist_items
        .map((x) => new ProductPricelistItemDecorator(x))
        .sort((a, b) => a.position - b.position),

      payment_profile_product_attachments: data.payment_profile_product_attachments.map(
        (x) => new PaymentProfileProductAttachmentDecorator(x)
      ),

      product_pickup_points: data.product_pickup_points
        .map((x) => new ProductPickupPointDecorator(x))
        .sort((a, b) => a.position - b.position),
    });
  }

  get current_product_pricelist_items() {
    return this.product_pricelist_items.filter(
      (item) => !item.pricelist_type || item.pricelist_type === this.pricelist_type
    );
  }

  get default_product_pricelist_item() {
    return this.product_pricelist_items[0];
  }

  get available_locales() {
    return this.translations.map((t) => t.locale);
  }

  get default_locale() {
    if (this.available_locales.indexOf(I18n.locale) !== -1) {
      return I18n.locale;
    } else if (this.available_locales.indexOf("en") !== -1) {
      return "en";
    } else {
      return this.translations[0] && this.translations[0].locale;
    }
  }

  get translation() {
    return (
      this.translations.find((t) => t.locale === this.default_locale) || {
        uuid: this.default_locale,
        locale: this.default_locale,
      }
    );
  }

  get name() {
    return this.translation && this.translation.name;
  }

  get total_stock_left() {
    return this.total_stock_limit === null ? Infinity : this.total_stock_limit - this.total_stock_used;
  }

  get coupon_discount_amount_or_percentage() {
    if (this.coupon_discount_amount) {
      return this.coupon_discount_amount;
    } else {
      return {
        value: this.coupon_discount_percentage,
        currency: "percentage",
      };
    }
  }

  set coupon_discount_amount_or_percentage(amount) {
    if (!amount) {
      this.coupon_discount_amount = null;
      this.coupon_discount_percentage = null;
    } else if (amount.currency === "percentage") {
      this.coupon_discount_amount = null;
      this.coupon_discount_percentage = amount.value;
    } else {
      this.coupon_discount_amount = amount;
      this.coupon_discount_percentage = null;
    }
  }

  get coupon_offer_price() {
    if (this.coupon_discount_amount && this.coupon_offer_price_before_discount) {
      return {
        value: this.coupon_offer_price_before_discount.value - this.coupon_discount_amount.value,
        currency: this.coupon_offer_price_before_discount.currency,
      };
    } else if (this.coupon_discount_percentage && this.coupon_offer_price_before_discount) {
      return {
        value:
          ~~(this.coupon_offer_price_before_discount.value * ((100 - this.coupon_discount_percentage) / 100) * 100) /
          100,
        currency: this.coupon_offer_price_before_discount.currency,
      };
    } else {
      return null;
    }
  }

  set coupon_offer_price(v) {
    if (this.coupon_discount_amount) {
      this.coupon_offer_price_before_discount = {
        value: v.value + this.coupon_discount_amount.value,
        currency: v.currency,
      };
    } else if (this.coupon_discount_percentage) {
      this.coupon_offer_price_before_discount = {
        value: v.value * (100 / (100 - this.coupon_discount_percentage)),
        currency: v.currency,
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductVariantFullDecorator.js